var render = function render(){var _vm=this,_c=_vm._self._c;return _c('calendar-main',{attrs:{"get-events":_vm.getEvents,"get-categories":_vm.getCategories,"add-permission":_vm.hasAddPermission,"edit-permission":_vm.hasEditPermission,"delete-permission":_vm.hasDeletePermission},on:{"delete-event":_vm.handleDelete}})
}
var staticRenderFns = []

export { render, staticRenderFns }